import React, { PropsWithChildren } from 'react';
import closeIcon from '../../../icons/close.svg';


interface HeaderProps {
	children: any
	closeModal?: () => void;
}

export const Header: React.FC<PropsWithChildren<HeaderProps>> = ({ children, closeModal }) => {

	const handleButtonClick = () => {
		closeModal?.();
	};

	const headerButton = (disabled = false) => {
		return <div className={`${disabled ? 'opacity-0 cursor-default pointer-events-none' : ''} p-4 rounded-2xl flex justify-center items-center bg-tablz-med-gray-2 cursor-pointer border border-tablz-med-gray-4`} onClick={handleButtonClick}>
			<img src={closeIcon} alt="Close icon" width={20} height={20} />
		</div>;
	};


	return (
		<div className='flex justify-between p-2 bg-tablz-dark-gray-1 items-center border-b border-tablz-med-gray-4 min-h-[52px]'>
			{closeModal ? headerButton(true) : ''}
			<header className="w-full flex justify-center items-center">
				{children}
			</header>
			{closeModal ? headerButton() : ''}
		</div>
	);
};
